import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _GlimmerHeader;
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { getOwner } from "@ember/application";
import { hash } from "@ember/helper";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { modifier } from "ember-modifier";
import { and, eq, not, or } from "truth-helpers";
import PluginOutlet from "discourse/components/plugin-outlet";
import DAG from "discourse/lib/dag";
import scrollLock from "discourse/lib/scroll-lock";
import DiscourseURL from "discourse/lib/url";
import { scrollTop } from "discourse/mixins/scroll-top";
import AuthButtons from "./header/auth-buttons";
import Contents from "./header/contents";
import HamburgerDropdownWrapper from "./header/hamburger-dropdown-wrapper";
import Icons from "./header/icons";
import SearchMenuWrapper from "./header/search-menu-wrapper";
import UserMenuWrapper from "./header/user-menu-wrapper";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
const SEARCH_BUTTON_ID = "search-button";
let headerButtons;
resetHeaderButtons();
function resetHeaderButtons() {
  headerButtons = new DAG({
    defaultPosition: {
      before: "auth"
    }
  });
  headerButtons.add("auth");
}
export function headerButtonsDAG() {
  return headerButtons;
}
export function clearExtraHeaderButtons() {
  resetHeaderButtons();
}
let GlimmerHeader = (_class = (_GlimmerHeader = class GlimmerHeader extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "router", _descriptor, this);
    _initializerDefineProperty(this, "search", _descriptor2, this);
    _initializerDefineProperty(this, "currentUser", _descriptor3, this);
    _initializerDefineProperty(this, "siteSettings", _descriptor4, this);
    _initializerDefineProperty(this, "site", _descriptor5, this);
    _initializerDefineProperty(this, "appEvents", _descriptor6, this);
    _initializerDefineProperty(this, "header", _descriptor7, this);
    _initializerDefineProperty(this, "skipSearchContext", _descriptor8, this);
    _defineProperty(this, "appEventsListeners", modifier(() => {
      this.appEvents.on("header:keyboard-trigger", this, this.headerKeyboardTrigger);
      return () => {
        this.appEvents.off("header:keyboard-trigger", this, this.headerKeyboardTrigger);
      };
    }));
  }
  headerKeyboardTrigger(msg1) {
    switch (msg1.type) {
      case "search":
        this.toggleSearchMenu();
        break;
      case "user":
        this.toggleUserMenu();
        break;
      case "hamburger":
        this.toggleNavigationMenu();
        break;
      case "page-search":
        if (!this.togglePageSearch()) {
          msg1.event.preventDefault();
          msg1.event.stopPropagation();
        }
        break;
    }
  }
  toggleSearchMenu() {
    if (this.site.mobileView) {
      const context1 = this.search.searchContext;
      let params1 = "";
      if (context1) {
        params1 = `?context=${context1.type}&context_id=${context1.id}&skip_context=${this.skipSearchContext}`;
      }
      if (this.router.currentRouteName === "full-page-search") {
        scrollTop();
        document.querySelector(".full-page-search").focus();
        return false;
      } else {
        return DiscourseURL.routeTo("/search" + params1);
      }
    }
    this.search.visible = !this.search.visible;
    if (!this.search.visible) {
      this.search.highlightTerm = "";
      this.search.inTopicContext = false;
      document.getElementById(SEARCH_BUTTON_ID)?.focus();
    }
  }
  togglePageSearch() {
    this.search.inTopicContext = false;
    let showSearch1 = this.router.currentRouteName.startsWith("topic.");
    // If we're viewing a topic, only intercept search if there are cloaked posts
    if (showSearch1) {
      const container1 = getOwner(this);
      const topic1 = container1.lookup("controller:topic");
      const total1 = topic1.get("model.postStream.stream.length") || 0;
      const chunkSize1 = topic1.get("model.chunk_size") || 0;
      showSearch1 = total1 > chunkSize1 && document.querySelectorAll(".topic-post .cooked, .small-action:not(.time-gap)")?.length < total1;
    }
    if (this.search.visible) {
      this.toggleSearchMenu();
      return showSearch1;
    }
    if (showSearch1) {
      this.search.inTopicContext = true;
      this.toggleSearchMenu();
      return false;
    }
    return true;
  }
  toggleUserMenu() {
    this.header.userVisible = !this.header.userVisible;
    this.toggleBodyScrolling(this.header.userVisible);
    this.args.animateMenu();
  }
  toggleNavigationMenu() {
    let override1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (override1 === "sidebar") {
      return this.toggleSidebar();
    }
    if (override1 === "hamburger") {
      return this.toggleHamburger();
    }
    if (this.args.sidebarEnabled && !this.site.narrowDesktopView) {
      this.toggleSidebar();
    } else {
      this.toggleHamburger();
    }
  }
  toggleHamburger() {
    this.header.hamburgerVisible = !this.header.hamburgerVisible;
    this.toggleBodyScrolling(this.header.hamburgerVisible);
    this.args.animateMenu();
  }
  toggleSidebar() {
    this.args.toggleSidebar();
    this.args.animateMenu();
  }
  toggleBodyScrolling(bool1) {
    if (this.site.mobileView) {
      scrollLock(bool1);
    }
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    <header class="d-header" {{this.appEventsListeners}}>
      <div class="wrap">
        <Contents
          @sidebarEnabled={{@sidebarEnabled}}
          @toggleNavigationMenu={{this.toggleNavigationMenu}}
          @showSidebar={{@showSidebar}}
        >
          <span class="header-buttons">
            {{#each (headerButtons.resolve) as |entry|}}
              {{#if (and (eq entry.key "auth") (not this.currentUser))}}
                <AuthButtons
                  @showCreateAccount={{@showCreateAccount}}
                  @showLogin={{@showLogin}}
                  @canSignUp={{@canSignUp}}
                />
              {{else if entry.value}}
                <entry.value />
              {{/if}}
            {{/each}}
          </span>

          {{#if
            (not (and this.siteSettings.login_required (not this.currentUser)))
          }}
            <Icons
              @sidebarEnabled={{@sidebarEnabled}}
              @toggleSearchMenu={{this.toggleSearchMenu}}
              @toggleNavigationMenu={{this.toggleNavigationMenu}}
              @toggleUserMenu={{this.toggleUserMenu}}
              @searchButtonId={{SEARCH_BUTTON_ID}}
            />
          {{/if}}

          {{#if this.search.visible}}
            <SearchMenuWrapper @closeSearchMenu={{this.toggleSearchMenu}} />
          {{else if this.header.hamburgerVisible}}
            <HamburgerDropdownWrapper
              @toggleNavigationMenu={{this.toggleNavigationMenu}}
              @sidebarEnabled={{@sidebarEnabled}}
            />
          {{else if this.header.userVisible}}
            <UserMenuWrapper @toggleUserMenu={{this.toggleUserMenu}} />
          {{/if}}

          {{#if
            (and
              (or this.site.mobileView this.site.narrowDesktopView)
              (or this.header.hamburgerVisible this.header.userVisible)
            )
          }}
            <div class="header-cloak"></div>
          {{/if}}
        </Contents>
      </div>
      <PluginOutlet
        @name="after-header"
        @outletArgs={{hash minimized=(globalThis.Boolean this.header.topic)}}
      />
    </header>
  
*/
{
  "id": "84qmszzG",
  "block": "[[[1,\"\\n    \"],[11,\"header\"],[24,0,\"d-header\"],[4,[30,0,[\"appEventsListeners\"]],null,null],[12],[1,\"\\n      \"],[10,0],[14,0,\"wrap\"],[12],[1,\"\\n        \"],[8,[32,0],null,[[\"@sidebarEnabled\",\"@toggleNavigationMenu\",\"@showSidebar\"],[[30,1],[30,0,[\"toggleNavigationMenu\"]],[30,2]]],[[\"default\"],[[[[1,\"\\n          \"],[10,1],[14,0,\"header-buttons\"],[12],[1,\"\\n\"],[42,[28,[31,1],[[28,[31,1],[[28,[32,1,[\"resolve\"]],null,null]],null]],null],null,[[[41,[28,[32,2],[[28,[32,3],[[30,3,[\"key\"]],\"auth\"],null],[28,[32,4],[[30,0,[\"currentUser\"]]],null]],null],[[[1,\"                \"],[8,[32,5],null,[[\"@showCreateAccount\",\"@showLogin\",\"@canSignUp\"],[[30,4],[30,5],[30,6]]],null],[1,\"\\n\"]],[]],[[[41,[30,3,[\"value\"]],[[[1,\"                \"],[8,[30,3,[\"value\"]],null,null,null],[1,\"\\n              \"]],[]],null]],[]]]],[3]],null],[1,\"          \"],[13],[1,\"\\n\\n\"],[41,[28,[32,4],[[28,[32,2],[[30,0,[\"siteSettings\",\"login_required\"]],[28,[32,4],[[30,0,[\"currentUser\"]]],null]],null]],null],[[[1,\"            \"],[8,[32,6],null,[[\"@sidebarEnabled\",\"@toggleSearchMenu\",\"@toggleNavigationMenu\",\"@toggleUserMenu\",\"@searchButtonId\"],[[30,1],[30,0,[\"toggleSearchMenu\"]],[30,0,[\"toggleNavigationMenu\"]],[30,0,[\"toggleUserMenu\"]],[32,7]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"search\",\"visible\"]],[[[1,\"            \"],[8,[32,8],null,[[\"@closeSearchMenu\"],[[30,0,[\"toggleSearchMenu\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"header\",\"hamburgerVisible\"]],[[[1,\"            \"],[8,[32,9],null,[[\"@toggleNavigationMenu\",\"@sidebarEnabled\"],[[30,0,[\"toggleNavigationMenu\"]],[30,1]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"header\",\"userVisible\"]],[[[1,\"            \"],[8,[32,10],null,[[\"@toggleUserMenu\"],[[30,0,[\"toggleUserMenu\"]]]],null],[1,\"\\n          \"]],[]],null]],[]]]],[]]],[1,\"\\n\"],[41,[28,[32,2],[[28,[32,11],[[30,0,[\"site\",\"mobileView\"]],[30,0,[\"site\",\"narrowDesktopView\"]]],null],[28,[32,11],[[30,0,[\"header\",\"hamburgerVisible\"]],[30,0,[\"header\",\"userVisible\"]]],null]],null],[[[1,\"            \"],[10,0],[14,0,\"header-cloak\"],[12],[13],[1,\"\\n\"]],[]],null],[1,\"        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[32,12],null,[[\"@name\",\"@outletArgs\"],[\"after-header\",[28,[32,13],null,[[\"minimized\"],[[28,[32,14,[\"Boolean\"]],[[30,0,[\"header\",\"topic\"]]],null]]]]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[\"@sidebarEnabled\",\"@showSidebar\",\"entry\",\"@showCreateAccount\",\"@showLogin\",\"@canSignUp\"],false,[\"each\",\"-track-array\",\"if\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/header.js",
  "scope": () => [Contents, headerButtons, and, eq, not, AuthButtons, Icons, SEARCH_BUTTON_ID, SearchMenuWrapper, HamburgerDropdownWrapper, UserMenuWrapper, or, PluginOutlet, hash, globalThis],
  "isStrictMode": true
}), _GlimmerHeader), _GlimmerHeader), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "search", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "siteSettings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "site", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "appEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "header", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "skipSearchContext", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.site.mobileView;
  }
}), _applyDecoratedDescriptor(_class.prototype, "headerKeyboardTrigger", [action], Object.getOwnPropertyDescriptor(_class.prototype, "headerKeyboardTrigger"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSearchMenu", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSearchMenu"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "togglePageSearch", [action], Object.getOwnPropertyDescriptor(_class.prototype, "togglePageSearch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleUserMenu", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleUserMenu"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleNavigationMenu", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleNavigationMenu"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleHamburger", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleHamburger"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSidebar", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSidebar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleBodyScrolling", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleBodyScrolling"), _class.prototype)), _class);
export { GlimmerHeader as default };